import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Checkbox } from '@bingads-webui-react/checkbox';

export class ApplyFeedbackForm extends React.PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,
    cid: PropTypes.string.isRequired,
    aid: PropTypes.string.isRequired,
    odata: PropTypes.PropTypes.shape({
      patch: PropTypes.func.isRequired,
    }).isRequired,
    onAutoApplyCancel: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    newI18n: PropTypes.PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }),
    permissions: PropTypes.objectOf(PropTypes.any),
    isFromImgExtV2: PropTypes.bool,
  };

  static defaultProps = {
    newI18n: {
      getString: _.noop,
    },
    permissions: {},
    isFromImgExtV2: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      autoApplyChecked: false,
    };
  }

  onApply = (e) => {
    e.stopPropagation();
    const {
      onSubmit, cid, aid, odata, onAutoApplyCancel, type, dataService, isFromImgExtV2,
    } = this.props;
    const { autoApplyChecked } = this.state;
    if (autoApplyChecked) {
      const op = {
        isOptInStatusDelta: {
          [type]: true,
        },
      };
      dataService.setAutoApplyOptInStatus(op).then(() => {
        onSubmit();
      });
    } else if (isFromImgExtV2) {
      const url = `Customers(${cid})/Accounts(${aid})`;
      const options = {
        data: {
          AllowCrawlImagesFromLandingPage: 'true',
        },
      };
      // Set Auto-retreive image option as true and then apply all
      odata.patch(url, options).then(() => {
        onSubmit();
      });
    } else {
      onAutoApplyCancel();
      onSubmit();
    }
  };

  handleAutoApplyOptionChange = () => {
    if (this.state.autoApplyChecked) {
      this.setState({
        autoApplyChecked: false,
      });
    } else {
      this.setState({
        autoApplyChecked: true,
      });
    }
  };

  render() {
    const {
      i18n,
      onCancel,
      permissions,
      newI18n,
      isFromImgExtV2,
      cid,
      aid,
    } = this.props;
    const { autoApplyChecked } = this.state;

    let title = i18n.getString('Recommendation_Feedback_Auto_Apply_Title');
    let instruction = i18n.getString('Recommendation_Feedback_Auto_Apply_Instructions');
    let submitText = i18n.getString('Summary_Card_Apply_All');

    if (permissions.IsRSAAutoApplyEnabled) {
      title = newI18n.getString(_TL_('Apply all recommendations?'));
      instruction = newI18n.getString(_TL_('Allow Microsoft Advertising to automatically apply this type of ad recommendations for you? You can opt out of auto-apply ad recommendations in your account settings at any time.'));
    }

    if (isFromImgExtV2) {
      title = newI18n.getString(_TL_('Auto-retrieve images from your websites'));
      submitText = newI18n.getString(_TL_('Allow and apply'));
      instruction = (
        <div>
          <div>
            {newI18n.getString(_TL_('Some images selected are from your website. By clicking “Allow and apply,” you agree that all images retrieved from your website are content provided by you the'))}
            <span>&nbsp;</span>
            <a href="https://about.ads.microsoft.com/en-us/resources/policies/microsoft-advertising-agreement" target="_apexPlatformHelp">
              {newI18n.getString(_TL_('Microsoft Advertising Agreement'))}
            </a>
            <span>.</span>
          </div>
          <div>
            {newI18n.getString(_TL_('You can change your image auto-retrieval settings anytime'))}
            <span>&nbsp;</span>
            <a
              href={`/campaign/vnext/accountsettings?cid=${cid}&aid=${aid}`}
            >
              {newI18n.getString(_TL_('here'))}
            </a>
            <span>.</span>
          </div>
        </div>
      );
    }

    return (
      <div className="recommendation-feedback-form">
        <h3>{ title }</h3>
        {isFromImgExtV2 ? instruction : (
          <table border="0">
            <tbody>
              <tr>
                <td valign="top">
                  <Checkbox
                    key="checkbox_auto_apply"
                    id="checkbox_auto_apply"
                    checked={autoApplyChecked}
                    onChange={this.handleAutoApplyOptionChange}
                  />
                </td>
                <td>
                  { instruction }&nbsp;
                  {!permissions.IsRSAAutoApplyEnabled &&
                    <button
                      className="HelpTopic btnlink learn-more"
                      query="help:ext56889"
                      aria-label={instruction}
                    >
                      {i18n.getString('Learn_more_link_text')}
                    </button>
                  }
                </td>
              </tr>
            </tbody>
          </table>
        )}
        <p />
        <div className="actions form-inline">
          <button
            className="btn btn-hero btn-primary submit"
            onClick={this.onApply}
          >
            { submitText }
          </button>
          <button className="btn btn-default cancel" onClick={onCancel}>{ i18n.getString('Recommendation_Feedback_Cancel') }</button>
        </div>
      </div>
    );
  }
}
